import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.175 7.128a2.87 2.87 0 0 0 .992-2.17 2.917 2.917 0 0 0-5.834 0 2.87 2.87 0 0 0 .992 2.17 4.67 4.67 0 0 0-2.742 4.247.583.583 0 0 0 1.167 0 3.5 3.5 0 1 1 7 0 .583.583 0 0 0 1.167 0 4.67 4.67 0 0 0-2.742-4.247m-1.925-.42a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5m5.682.187A2.916 2.916 0 0 0 8.75 2.042a.583.583 0 0 0 0 1.166 1.75 1.75 0 0 1 1.514 2.623 1.75 1.75 0 0 1-.639.638.583.583 0 0 0-.03.992l.228.152.076.04a4.08 4.08 0 0 1 2.334 3.722.583.583 0 0 0 1.166 0 5.25 5.25 0 0 0-2.467-4.48"
    }, null, -1)
  ])))
}
export default { render: render }